import React, { type PropsWithChildren } from 'react'
import { Button, LinkPrimitive } from '@figma/fpl-components'
import { ColorTheme } from '@figma/fpl-themes'
import { color } from '@figma/fpl-tokens/tokens.stylex'
import { t } from '@figma/i18n/translation'
import { authFigmaLogoLabel } from '@figma/i18n-dictionaries/en/web/auth'
import stylex from '@web/lib/stylex'
import logo from '@web/ui-platform/images/logomark.svg'
import { Svg } from '@web/ui-platform/svg_deprecated'

import * as styles from './simple_page.css'

const stylexStyles = stylex.create({
  logo: {
    width: '32px',
    marginTop: '24px',
    marginLeft: '32px',
    cursor: 'pointer',
    outline: {
      default: 'none',
      ':focus-visible': `2px solid ${color.borderSelected}`,
    },
  },
})

interface SimplePageProps {
  headerAction?: () => void
  headerActionText?: string
  className?: string
}

export function SimplePage(props: PropsWithChildren<SimplePageProps>) {
  return (
    <div className={`${styles.page} ${props.className}`}>
      {props.headerAction && props.headerActionText && (
        // Using data-preferred-theme="dark" to force dark mode ghost which is white text on dark background
        <ColorTheme mode="dark">
          <div className={styles.header}>
            <Button variant="ghost" onClick={props.headerAction}>
              {props.headerActionText}
            </Button>
          </div>
        </ColorTheme>
      )}
      <LinkPrimitive
        href="/"
        aria-label={t(authFigmaLogoLabel)}
        {...stylex.props(stylexStyles.logo)}
      >
        <Svg
          ariaHidden
          svg={logo}
          useOriginalSrcFills_DEPRECATED={true}
          autosize={true}
          width="32px"
        />
      </LinkPrimitive>
      {props.children}
    </div>
  )
}
